var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import Modal from "./Semantic/Modal";
import Button from "./Semantic/Button";
import ToggleDarkMode from "./ToggleDarkMode";
import ColorAssistToggle from "./ColorAssistToggle";
import styles from "../styles/SettingsModal.module.scss";
var SettingsModal = function () {
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    return (_jsxs(_Fragment, { children: [_jsx(Button, { onClick: function () { return setOpen(true); }, icon: "settings" }, void 0), _jsxs(Modal, __assign({ open: open, onClose: function () { return setOpen(false); }, size: "mini", closeIcon: true }, { children: [_jsx(Modal.Header, { children: "Settings" }, void 0), _jsxs(Modal.Content, __assign({ className: styles.modalContent }, { children: [_jsx(ToggleDarkMode, {}, void 0), _jsx(ColorAssistToggle, {}, void 0)] }), void 0)] }), void 0)] }, void 0));
};
export default SettingsModal;
